module.exports = __webpack_public_path__ + "static/media/smeta-macmap.c61d8b61.png";